import { __assign } from 'tslib';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "DownloadManagerCGU";
var classes = {
    checkContainer: "".concat(PREFIX, "-checkContainer"),
    checkContainerActive: "".concat(PREFIX, "-checkContainerActive"),
    checkContainerError: "".concat(PREFIX, "-checkContainerError"),
    list: "".concat(PREFIX, "-list"),
    listItem: "".concat(PREFIX, "-listItem"),
    listItemText: "".concat(PREFIX, "-listItemText"),
    listNested: "".concat(PREFIX, "-listNested"),
    listItemNested: "".concat(PREFIX, "-listItemNested"),
    listItemTextNested: "".concat(PREFIX, "-listItemTextNested"),
    close: "".concat(PREFIX, "-close"),
    open: "".concat(PREFIX, "-open"),
    "break": "".concat(PREFIX, "-break")
};
var StyledDownloadManagerCSU = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "activeRoot"; }
})(function (_a) {
    var _b;
    var theme = _a.theme, activeRoot = _a.activeRoot;
    return (__assign(__assign({ width: "50%", margin: "auto", padding: theme.spacing(2), borderRadius: theme.shape.borderRadius, transition: "border ".concat(theme.transitions.duration.short, " ").concat(theme.transitions.easing.easeInOut), border: "1px solid transparent" }, (activeRoot && { borderColor: theme.palette.divider })), (_b = {}, _b["& .".concat(classes.checkContainer)] = {
        background: theme.palette.background.paper,
        padding: theme.spacing(0),
        transition: "all ".concat(theme.transitions.duration.short, " ").concat(theme.transitions.easing.easeInOut),
        margin: theme.spacing(-2),
        border: "1px solid transparent",
        borderRadius: theme.shape.borderRadius
    }, _b["& .".concat(classes.checkContainerActive)] = {
        margin: theme.spacing(0),
        padding: theme.spacing(2),
        borderColor: theme.palette.primary.main
    }, _b["& .".concat(classes.checkContainerError)] = {
        borderColor: theme.palette.error.main,
        padding: theme.spacing(2)
    }, _b["& .".concat(classes.list)] = {}, _b["& .".concat(classes.listItem)] = {
        display: "inline-block",
        width: "100%"
    }, _b["& .".concat(classes.listItemText)] = {
        width: "100%",
        borderBottom: "1px solid ".concat(theme.palette.divider)
    }, _b["& .".concat(classes.listNested)] = {
        width: "100%",
        paddingLeft: theme.spacing(2)
    }, _b["& .".concat(classes.listItemNested)] = {}, _b["& .".concat(classes.listItemTextNested)] = {}, _b["& .".concat(classes.close)] = {
        marginBottom: theme.spacing(2)
    }, _b["& .".concat(classes.open)] = {
        color: theme.palette.primary.main,
        fontWeight: "bold",
        fontFamily: theme.typography.fontFamily,
        textDecoration: "underline",
        appearance: "none",
        border: "none",
        outline: "none",
        backgroundColor: "transparent",
        padding: 0,
        margin: 0,
        fontSize: "100%",
        display: "inline-block",
        cursor: "pointer",
        verticalAlign: "unset"
    }, _b["& .".concat(classes["break"])] = {
        wordBreak: "break-all"
    }, _b)));
});

export { classes, StyledDownloadManagerCSU as default };
//# sourceMappingURL=index.styled.js.map
